export default __webpack_public_path__ + "static/media/Leggings of Quilled Darts.798ef8b7.jpg";